import { render } from "./Admin.vue?vue&type=template&id=503a4f6c"
import script from "./Admin.ts?vue&type=script&lang=js&external"
export * from "./Admin.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__